import { Button, TextField } from "@material-ui/core";
import React from "react";
import Media from "react-media";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { ISuperUserDto } from "../../models/SuperUserDto";
import { ITerminalDto } from "../../models/TerminalDto";
import { TidStatusDto } from "../../models/TidStatusDto";
import { UserDetailsState } from "../../states/UserDetailsState";
import { UserType } from "../../utils/UserTypeEnum";
import { Subscription } from "rxjs";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { UserUtils } from "../../utils/UserUtils";
import StateBadge from "../../components/badge/StateBadge";
import Skeleton from "react-loading-skeleton";
import { IUserDetailsDto } from "../../models/UserDetailsDto";
import { IDeveloperDetailsDto } from "../../models/DeveloperDetailsDto";
import { StringUtils } from "../../utils/StringUtils";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { MposLoader } from "../../components/loader/MposLoader";
import { Route } from "react-router-dom";
import { UpdateUserRequest } from "../../models/UpdateUserDetails";
import { TerminalItemDto } from "../../models/TerminalInfoDto";
import { TerminalOperationType } from "../../utils/TerminalOperationTypeEnum";
import * as querystring from "querystring";
import { Mapper } from "../../utils/Mapper";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import { ITerminalsDto } from "../../models/TerminalsDto";
import StateContextProvider from "../../context/StateContext";
import { HTTPResponses } from "../../models/HTTPResponses";
import "./UserDetails.scss";

export class UserDetails extends React.Component<any, UserDetailsState> {
    private adminSubscription: Subscription | null = null;
    private staffSubscription: Subscription | null = null;
    private getTerminalsSubscription: Subscription | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            user: null,
            developer: null,
            showConfirmForRevokeUser: false,
            showLoader: false,
            revokeUserResult: false,
            showRevokeUserResultDialog: false,
            showConfirmForChangePwd: false,
            showChangePwdResultDialog: false,
            changePwdResult: false,
            updateUserModifyClicked: false,
            descriptionValue: "",
            superUserTidNumbersAvailable: null,
            saveButtonDisabled: true,
            username: "",
            userType: UserType.STAFF,
            description: "",
            terminalStatus: TidStatusDto.NOT_ASSIGNED,
            backgroundHeaderColor: "",
            userdetailsError: false,
            superuserDetailsError: false,
            terminalList: null,
            mobilePosList: [],
            softPosList: [],
            sameTerminalsType: false,
            revokeDeveloperResult: false,
        };

        this.handleDescriptionChanges = this.handleDescriptionChanges.bind(this);
    }

    componentDidMount() {
        this.setState({ sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType") });

        // Get Terminals
        this.getTerminalsSubscription = MposWebPortalApi.getInstance()
            .getTerminals()
            .subscribe(
                (terminalsDto: ITerminalsDto) => {
                    this.setState({ terminalList: terminalsDto });
                    const arrMpos = this.filterByStatusAndType(terminalsDto.terminals!, "MPOS", TidStatusDto.ACTIVE);
                    this.setState({ mobilePosList: arrMpos });
                    const arrSoftPos = this.filterByStatusAndType(terminalsDto.terminals!, "SOFTPOS", TidStatusDto.ACTIVE);
                    this.setState({ softPosList: arrSoftPos });
                },
                (error) => {
                    this.setState({ terminalList: null });
                    this.setState({ isLoading: false });
                }
            );

        // Check if username in params is provided
        if (this.props.match === undefined || this.props.match.params === undefined || this.props.match.params.id === undefined) {
            this.props.history.replace("/users");
        } else {
            // Check mandatory query params
            let usernameFromParams = this.props.match.params.id;
            this.setState({ username: usernameFromParams });
            let params = querystring.parse(this.props.location.search.replace("?", ""));
            if (!Mapper.checkMandatoryParams(params)) {
                this.props.history.replace("/users");
            } else {
                // Check if for the first time users is called!
                const cachedUsers: string[] = UserUtils.getCachedUsers();
                const cachedDevelopers: string[] = UserUtils.getCachedDevelopers();
                /* if (cachedUsers.length === 0 || cachedDevelopers.length === 0) {
                    this.props.history.replace("/users");
                } else { */
                    let isValidUser = cachedUsers.includes(usernameFromParams);
                    let isValidDeveloper = cachedDevelopers.includes(usernameFromParams);
                    if (isValidUser || isValidDeveloper) {
                        this.setState({ userType: Mapper.mapParamToUserType(typeof params.userType === "string" ? params.userType : params.userType[0]) }, () => {
                            if (this.state.userType === UserType.ADMIN) {
                                this.setState({ isLoading: true });
                                this.adminSubscription = MposWebPortalApi.getInstance()
                                    .getSuperUserDetails()
                                    .subscribe(
                                        (superUserDto: ISuperUserDto) => {
                                            let userAdmin = UserUtils.mapSuperUserToUserDetailsDto(superUserDto);
                                            this.setState({ isLoading: false });
                                            this.setState({ user: userAdmin }, () => {
                                                // Send GTM Admin
                                                let path;
                                                path = this.props.history.location.pathname.split("/")[1] + this.props.location.search;
                                                GoogleTagManagerService.getInstance().pushPageEvent(path, "Dettaglio utente", {});
                                            });
                                            this.setState({ superUserTidNumbersAvailable: superUserDto.numberOfTerminals });
                                            this.setState({ userType: UserType.ADMIN });
                                            this.setState({ description: userAdmin.description !== null ? userAdmin.description : "" });
                                            if (this.state.sameTerminalsType) {
                                                this.setState(
                                                    { terminalStatus: userAdmin.terminalInfo?.length !== 0 ? userAdmin.terminalInfo![0].terminalStatus : TidStatusDto.NOT_ASSIGNED },
                                                    () => {
                                                        switch (this.state.terminalStatus) {
                                                            case TidStatusDto.ACTIVE:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #44E8A2 0%, #35D490 50.63%, #29BE7E 100%)" });
                                                                break;
                                                            case TidStatusDto.SUSPENDED:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #FA796D 0%, #F86E62 52.66%, #E16055 100%)" });
                                                                break;
                                                            case TidStatusDto.NOT_ASSIGNED:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                                                break;
                                                        }
                                                    }
                                                );
                                            }
                                            this.setState({ superuserDetailsError: false });
                                        },
                                        () => {
                                            this.setState({ isLoading: false });
                                            this.setState({ superuserDetailsError: true });
                                            this.setState({ user: null });
                                            this.setState({ superUserTidNumbersAvailable: null });
                                            this.setState({ userType: UserType.ADMIN });
                                            this.setState({ description: "" });
                                            this.setState({ terminalStatus: TidStatusDto.NOT_ASSIGNED }, () => {
                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                            });
                                        }
                                    );
                            } else if (this.state.userType === UserType.STAFF) {
                                this.setState({ isLoading: true });
                                this.staffSubscription = MposWebPortalApi.getInstance()
                                    .userDetails(usernameFromParams)
                                    .subscribe(
                                        (userDto: IUserDetailsDto) => {
                                            this.setState({ isLoading: false });
                                            this.setState({ user: userDto }, () => {
                                                // Send GTM Staff
                                                let path;
                                                path = this.props.history.location.pathname.split("/")[1] + this.props.location.search;

                                                const terminalTemplate = (id: string | null | undefined, status: string | undefined) => ({
                                                    id: id,
                                                    status: status,
                                                });

                                                const terminalMobilePos = this.state.user?.terminalInfo?.find((terminal) => terminal.terminalType === "MPOS");
                                                const terminalSoftPos = this.state.user?.terminalInfo?.find((terminal) => terminal.terminalType === "SOFTPOS");

                                                let ObjMobilePos =
                                                    this.state.user?.terminalInfo?.length !== 0 && this.state.user?.terminalInfo?.find((terminal) => terminal.terminalType === "MPOS")
                                                        ? terminalTemplate(terminalMobilePos?.termId, terminalMobilePos?.terminalStatus.toLowerCase())
                                                        : terminalTemplate(null, "Non assegnato");

                                                let ObjSoftPos =
                                                    this.state.user?.terminalInfo?.length !== 0 && this.state.user?.terminalInfo?.find((terminal) => terminal.terminalType === "SOFTPOS")
                                                        ? terminalTemplate(terminalSoftPos?.termId, terminalSoftPos?.terminalStatus.toLowerCase())
                                                        : terminalTemplate(null, "Non assegnato");

                                                GoogleTagManagerService.getInstance().pushPageEvent(path, "Dettaglio utente", {
                                                    tid_mobile_pos: ObjMobilePos,
                                                    tid_soft_pos: ObjSoftPos,
                                                });
                                            });
                                            this.setState({ descriptionValue: userDto.description !== null ? userDto.description : "" });
                                            this.setState({ userType: UserType.STAFF });
                                            this.setState({ description: userDto.description !== null ? userDto.description : "" });
                                            if (this.state.sameTerminalsType) {
                                                this.setState(
                                                    { terminalStatus: userDto.terminalInfo?.length !== 0 ? userDto.terminalInfo![0].terminalStatus : TidStatusDto.NOT_ASSIGNED },
                                                    () => {
                                                        switch (this.state.terminalStatus) {
                                                            case TidStatusDto.ACTIVE:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #44E8A2 0%, #35D490 50.63%, #29BE7E 100%)" });
                                                                break;
                                                            case TidStatusDto.SUSPENDED:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #FA796D 0%, #F86E62 52.66%, #E16055 100%)" });
                                                                break;
                                                            case TidStatusDto.NOT_ASSIGNED:
                                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                                                break;
                                                        }
                                                    }
                                                );
                                            }
                                            this.setState({ userdetailsError: false });
                                        },
                                        () => {
                                            this.setState({ isLoading: false });
                                            this.setState({ userdetailsError: true });
                                            this.setState({ user: null });
                                            this.setState({ descriptionValue: "" });
                                            this.setState({ userType: UserType.STAFF });
                                            this.setState({ description: "" });
                                            this.setState({ terminalStatus: TidStatusDto.NOT_ASSIGNED }, () => {
                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                            });
                                        }
                                    );
                            } else if (this.state.userType === UserType.DEVELOPER) {
                                this.setState({ isLoading: true });
                                usernameFromParams = params.id;
                                this.staffSubscription = MposWebPortalApi.getInstance()
                                    .detailDeveloper(usernameFromParams)
                                    .subscribe(
                                        (developerDto: IDeveloperDetailsDto) => {
                                            this.setState({ isLoading: false });
                                            this.setState({ developer: developerDto }, () => {
                                                // Send GTM Developer
                                                let path;
                                                path = this.props.history.location.pathname.split("/")[1] + this.props.location.search;

                                                GoogleTagManagerService.getInstance().pushPageEvent(
                                                    path,
                                                    "Dettaglio utente", {
                                                    tid_mobile_pos: {
                                                        id: null,
                                                        status: "Non assegnato",
                                                    },
                                                    tid_soft_pos: {
                                                        id: null,
                                                        status: "Non assegnato",
                                                    },
                                                });
                                            });
                                            this.setState({
                                                descriptionValue: "",
                                                userType: UserType.DEVELOPER,
                                                description: 'Sviluppatore',
                                                userdetailsError: false
                                            });
                                        },
                                        () => {
                                            this.setState({
                                                isLoading: false,
                                                userdetailsError: true,
                                                user: null,
                                                descriptionValue: "",
                                                userType: UserType.STAFF,
                                                description: "",
                                                terminalStatus: TidStatusDto.NOT_ASSIGNED
                                            }, () => {
                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                            });
                                        }
                                    );
                            } else {
                                this.setState({ isLoading: true });
                                this.staffSubscription = MposWebPortalApi.getInstance()
                                    .detailDeveloper(usernameFromParams)
                                    .subscribe(
                                        (developerDto: IDeveloperDetailsDto) => {
                                            this.setState({ isLoading: false });
                                            this.setState({ developer: developerDto }, () => {
                                                // Send GTM Developer
                                                console.log("[UserDetails] GTM: DEVELOPER user");
                                                let path;
                                                path = this.props.history.location.pathname.split("/")[1] + this.props.location.search;

                                                GoogleTagManagerService.getInstance().pushPageEvent(
                                                    path,
                                                    "Dettaglio utente", {
                                                    tid_mobile_pos: {
                                                        id: null,
                                                        status: "Non assegnato",
                                                    },
                                                    tid_soft_pos: {
                                                        id: null,
                                                        status: "Non assegnato",
                                                    },
                                                });
                                            });
                                            this.setState({
                                                descriptionValue: "",
                                                userType: UserType.DEVELOPER,
                                                description: 'Sviluppatore',
                                                userdetailsError: false
                                            });
                                        },
                                        () => {
                                            this.setState({
                                                isLoading: false,
                                                userdetailsError: true,
                                                user: null,
                                                descriptionValue: "",
                                                userType: UserType.STAFF,
                                                description: "",
                                                terminalStatus: TidStatusDto.NOT_ASSIGNED
                                            }, () => {
                                                console.log("[UserDetails] Service TID status error: NOT ASSIGNED");
                                                this.setState({ backgroundHeaderColor: "linear-gradient(327.71deg, #BCBABA 0%, #A3A2A2 51.35%, #979797 100%)" });
                                            });
                                        }
                                    );
                            }
                        });
                        this.setState({
                            description: typeof params.description === "string" ? decodeURIComponent(params.description) : decodeURIComponent(params.description[0]),
                        });
                    } else {
                        // Not found!
                        this.props.history.replace("/404");
                    }
                //}
            }
        }
    }

    componentWillUnmount() {
        if (this.getTerminalsSubscription != null) {
            this.getTerminalsSubscription.unsubscribe();
        }

        if (this.adminSubscription !== null) {
            this.adminSubscription.unsubscribe();
        }

        if (this.staffSubscription !== null) {
            this.staffSubscription.unsubscribe();
        }
    }

    private filterByStatusAndType(arr: ITerminalDto[], type: string, status: string) {
        return arr.filter((el) => el.terminalType === type && el.tidStatus === status);
    }

    private handleDescriptionChanges(event: any) {
        this.setState({ descriptionValue: event.target.value });
        this.setState({ saveButtonDisabled: false });
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            // HERE: METTERE INDIETRO AL POSTO DELLA FRECCIA
            <HeaderDesktop
                showBack={true}
                showLogout={false}
                showTitle={true}
                title={""}
                hideBorder={true}
                background={!this.state.sameTerminalsType || this.state.userType === UserType.DEVELOPER ? "#262D58" : this.state.backgroundHeaderColor}
                buttonContentColor={"#FFFFFF"}
                isSpecial>
                <div className={"user-details-header-content"}>
                    <p className={"user-details-header-username"}>{this.state.username}</p>
                    <p className={this.state.userType === UserType.ADMIN ? "user-details-header-description-admin" : "user-details-header-description-staff"}>
                        {this.state.description === null || typeof this.state.description === "undefined" ? " " : this.state.description.toUpperCase()}
                    </p>
                    {(this.state.userType === UserType.STAFF) || (this.state.userType === UserType.DEVELOPER) ? (
                        <Button
                            id={"user-details-header-button-revoke"}
                            onClick={() => {
                                this.revokeUser();
                            }}
                            disableRipple
                        >
                            REVOCA {this.state.userType === UserType.DEVELOPER ? 'ABILITAZIONE' : 'UTENZA'}
                        </Button>
                    ) : null}
                </div>
            </HeaderDesktop>
        );
    }

    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile
                showBack={true}
                showLogout={false}
                showTitle={false}
                hideBorder={true}
                background={this.state.userType === UserType.DEVELOPER || !this.state.sameTerminalsType ? "#262D58" : this.state.backgroundHeaderColor}
                buttonContentColor={"#FFFFFF"}
                isSpecial>
                <div className={"user-details-header-content"}>
                    <p className={"user-details-header-username"}>{this.state.username}</p>
                    <p className={this.state.userType === UserType.ADMIN ? "user-details-header-description-admin" : "user-details-header-description-staff"}>
                        {this.state.description === null || typeof this.state.description === "undefined" ? " " : this.state.description.toUpperCase()}
                    </p>
                    {(this.state.userType === UserType.STAFF) || (this.state.userType === UserType.DEVELOPER) ? (
                        <Button
                            id={"user-details-header-button-revoke"}
                            onClick={() => {
                                this.revokeUser();
                            }}
                            disableRipple
                        >
                            REVOCA {this.state.userType === UserType.DEVELOPER ? 'ABILITAZIONE' : 'UTENZA'}
                        </Button>
                    ) : null}
                </div>
            </HeaderMobile>
        );
    }

    private superUserHasMoreThanOneTerminalAssignable(): boolean {
        return this.state.superUserTidNumbersAvailable !== null && this.state.superUserTidNumbersAvailable > 1;
    }

    private boxError(): JSX.Element {
        return (
            <div className="user-details-suspended-info-error">
                <p className="user-id-title-err">ID Terminale disattivi</p>
                {this.state.mobilePosList?.length !== 0 && this.state.softPosList?.length !== 0 ? (
                    <p className="msg-err-card"> Assegna un altro ID Terminale oppure contatta l'assistenza per approfondire.</p>
                ) : null}

                {this.state.mobilePosList?.length === 0 || this.state.softPosList?.length === 0 ? (
                    <p className="msg-err-card">
                        {" "}
                        Per approfondire contatta l'assistenza clienti numero <b>+39 02/34980519</b>.
                    </p>
                ) : null}
            </div>
        );
    }

    private checkAndShowErrors(): JSX.Element | null {
        let terminalInfo = this.state.user?.terminalInfo;

        if (terminalInfo?.filter((el) => el.terminalStatus === TidStatusDto.SUSPENDED).length === 2) {
            return this.boxError();
        }

        if (terminalInfo?.length === 0) {
            return (
                <div className="user-details-suspended-info-error-grey">
                    <p className="user-id-title-err">Vuoi rendere l'utente nuovamente operativo?</p>
                    <p className="user-msg-err">Assegnagli un ID Terminale attivo per permettergli di accettare pagamenti.</p>
                </div>
            );
        }
        return null;
    }

    private renderTerminalError(terminalStatus?: string, terminalType?: string): JSX.Element | null {
        if (terminalStatus !== TidStatusDto.SUSPENDED) {
            return null;
        }
        const terminalList = terminalType === "MPOS" ? this.state.mobilePosList : this.state.softPosList;
        const message =
            terminalList?.length !== 0 ? (
                <p className="msg-err-card">Assegna un altro ID Terminale oppure contatta l'assistenza per approfondire.</p>
            ) : (
                <p className="msg-err-card">
                    Per approfondire contatta l'assistenza clienti numero <b>+39 02/34980519</b>.
                </p>
            );
        return <div className="card-err">{message}</div>;
    }

    private boxErrorSub(terminalStatus?: string, terminalType?: string): JSX.Element | null {
        if (this.state.user?.terminalInfo?.filter((e) => e.terminalStatus === TidStatusDto.SUSPENDED).length !== 2) {
            return this.renderTerminalError(terminalStatus, terminalType);
        }
        return null;
    }

    private checkActionVisibility(terminalType: string | undefined) {
        const terminalInfo = this.state.user?.terminalInfo;
        const mobilePosList = this.state.mobilePosList;
        const softPosList = this.state.softPosList;
        const checkSuspended = terminalInfo?.filter((e) => e.terminalStatus === TidStatusDto.SUSPENDED);

        if (
            (checkSuspended?.length === 2 && mobilePosList!.length > 0 && softPosList!.length > 0) ||
            (checkSuspended?.length === 1 && (terminalType === 'MPOS' ? mobilePosList!.length > 0 : softPosList!.length > 0)) ||
            (checkSuspended?.length === 1 && (terminalType === 'MPOS' ? mobilePosList!.length === 0 : softPosList!.length === 0)) ||
            (terminalInfo?.length === 0) || (terminalInfo?.length === 1) ||
            (terminalType === 'MPOS' ? mobilePosList!.length > 0 : softPosList!.length > 0)
        ) {
            return true
        } else if (checkSuspended?.length === 2 && (mobilePosList!.length === 0 || softPosList!.length === 0)) {
            return false;
        }
        return null;
    }

    private userInfoBox(): JSX.Element {
        return (
            <div className={"user-details-container-content-table-first-column"}>
                <p className={"user-details-first-column-title"}>INFORMAZIONI UTENTE</p>
                <div className={"user-details-first-column-box"}>
                    {this.state.userType === UserType.STAFF ? (
                        <p className={"user-details-date"}>{"Creato il " + StringUtils.formatDate(this.state.user?.creation!)}</p>
                    ) : null}
                    <p className={"user-details-title"}>E-mail</p>
                    <p className={"user-details-content"}>{this.state.user?.email}</p>
                    {this.state.userType === UserType.STAFF ? (
                        <>
                            <p className={"user-details-title user-details-text-margined"}>Ruolo o punto vendita (opzionale)</p>
                            {!this.state.updateUserModifyClicked && (
                                <p className={"user-details-content"}>
                                    {this.state.user?.description === null || this.state.user?.description === "" ? "--" : this.state.user?.description}
                                </p>
                            )}
                            {this.state.updateUserModifyClicked && (
                                <TextField
                                    id={"user-detail-description-field"}
                                    type={"text"}
                                    onChange={this.handleDescriptionChanges}
                                    InputLabelProps={{ shrink: false }}
                                    value={this.state.descriptionValue}
                                    inputProps={{ maxLength: 20 }}
                                />
                            )}
                            {!this.state.updateUserModifyClicked && (
                                <Button
                                    id={"user-detail-button-change-info"}
                                    onClick={() => {
                                        this.handleChangeInfo();
                                    }}
                                    disableRipple>
                                    MODIFICA
                                </Button>
                            )}
                            {this.state.updateUserModifyClicked && (
                                <Route
                                    render={({ history }) => {
                                        return (
                                            <Button
                                                id={"user-detail-save-button"}
                                                onClick={() => {
                                                    this.saveUserInfo(history);
                                                }}
                                                type={"button"}
                                                disabled={this.state.saveButtonDisabled}>
                                                SALVA
                                            </Button>
                                        );
                                    }}
                                />
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        );
    }

    private tile(terminalId?: string, terminalStatus?: string, terminalType?: string): JSX.Element {
        return (
            <div className={"user-details-second-column-box"}>
                <div className={"user-details-terminal-info"}>
                    {this.state.sameTerminalsType ? (
                        <p className="user-details-terminal-id">{terminalId}</p>
                    ) : (
                        <>
                            <p className={"user-details-terminal-info-tid"}>{terminalType === "MPOS" ? "Mobile POS" : "SoftPOS"}</p>
                            {terminalStatus !== TidStatusDto.NOT_ASSIGNED ? (
                                <p className={"user-details-terminal"}>
                                    ID Terminale: <span className={"user-details-id"}>{terminalId}</span>
                                </p>
                            ) : null}
                        </>
                    )}
                    <StateBadge badgeStateText="non assegnato" userState={terminalStatus} />
                    {this.boxErrorSub(terminalStatus, terminalType)}
                </div>
                {this.state.user?.terminalInfo?.filter((el: TerminalItemDto) => el.terminalType === "MPOS").length === 2 ? this.boxError() : null}
                <Route
                    render={({ history }) => {
                        return (
                            this.checkActionVisibility(terminalType) &&
                            (
                                <Button
                                    id={"user-detail-button-change-tid"}
                                    disabled={this.state.userType === UserType.ADMIN ? !this.superUserHasMoreThanOneTerminalAssignable() : false}
                                    className={
                                        this.state.userType === UserType.ADMIN ? (this.superUserHasMoreThanOneTerminalAssignable() ? "" : "user-detail-change-button-hidden") : ""
                                    }
                                    onClick={() => {
                                        this.handleChangeTid(history, terminalStatus !== TidStatusDto.NOT_ASSIGNED, terminalType, terminalId)
                                    }}
                                    disableRipple
                                >
                                    {terminalStatus === TidStatusDto.NOT_ASSIGNED ? "ASSEGNA" : "MODIFICA"}
                                </Button>
                            )
                        );
                    }}
                />
            </div>
        );
    }

    private tilesList(): JSX.Element {
        return (
            <>
                {this.state.user?.terminalInfo?.length === 0 ||
                    (this.state.user?.terminalInfo?.length === 1 && this.state.user?.terminalInfo[0].terminalType === "SOFTPOS")
                    ? this.tile("", TidStatusDto.NOT_ASSIGNED, "MPOS")
                    : null}

                {this.state.user?.terminalInfo?.map((terminal: TerminalItemDto) => this.tile(terminal.termId, terminal.terminalStatus, terminal.terminalType))}

                {this.state.user?.terminalInfo?.length === 0 ||
                    (this.state.user?.terminalInfo?.length === 1 && this.state.user?.terminalInfo[0].terminalType === "MPOS")
                    ? this.tile("", TidStatusDto.NOT_ASSIGNED, "SOFTPOS")
                    : null}
            </>
        );
    }

    render() {
        return this.state.superuserDetailsError || this.state.userdetailsError ? (
            <ServiceUnavailablePage />
        ) : (
            <div id={"main-container-user-details"}>
                <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
                <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
                <div className={"user-details-container-content"}>
                    {this.state.isLoading && (
                        <div className={"user-details-container-content-table-row"}>
                            <div className={"user-details-container-content-table-first-column"}>
                                <p className={"user-details-first-column-title"}>INFORMAZIONI UTENTE</p>
                                {this.state.userType === UserType.ADMIN ? (
                                    <Skeleton className={"user-details-container-table-first-column-skeleton-admin"} />
                                ) : (
                                    <Skeleton className={"user-details-container-table-first-column-skeleton-staff"} />
                                )}
                            </div>
                            <div className={"user-details-container-content-table-second-column"}>
                                <p className={"user-details-second-column-title"}>ID TERMINALE</p>
                                <Skeleton className={"user-details-container-table-second-column-skeleton-admin"} />
                            </div>
                        </div>
                    )}
                    <div className={"user-details-container-content-table-row"}>
                        {/* Header User Info */}
                        {this.state.userType !== UserType.DEVELOPER ? (
                            !this.state.isLoading ? this.userInfoBox() : null
                        ) : null}

                        {/* Admin */}
                        {this.state.userType === UserType.ADMIN && !this.state.isLoading ? (
                            this.state.sameTerminalsType ? (
                                <div className={"user-details-container-content-table-second-column"}>
                                    <p className={"user-details-second-column-title"}>ID TERMINALE</p>
                                    <div className={"user-details-second-column-box"}>
                                        <div className={"user-details-terminal-info"}>
                                            <p className={"user-details-terminal-id"}>
                                                {this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined
                                                    ? "Nessuno"
                                                    : this.state.user?.terminalInfo![0].termId}
                                            </p>
                                            <StateBadge
                                                userState={
                                                    this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined
                                                        ? TidStatusDto.NOT_ASSIGNED
                                                        : this.state.user?.terminalInfo![0].terminalStatus
                                                }
                                            />
                                        </div>
                                        <Route
                                            render={({ history }) => {
                                                return (
                                                    <Button
                                                        id={"user-detail-button-change-tid"}
                                                        disabled={!this.superUserHasMoreThanOneTerminalAssignable()}
                                                        className={this.superUserHasMoreThanOneTerminalAssignable() ? "" : "user-detail-change-button-hidden"}
                                                        onClick={() =>
                                                            this.handleChangeTid(history, false, this.state.user?.terminalInfo![0].terminalType, this.state.user?.terminalInfo![0].termId)
                                                        }
                                                        disableRipple
                                                    >
                                                        MODIFICA
                                                    </Button>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                // Multi POS Type
                                <div className={"user-details-container-content-table-second-column"}>
                                    <p className={"user-details-second-column-title"}>ID TERMINALE</p>
                                    {this.state.user?.terminalInfo?.filter((el) => el.terminalStatus === TidStatusDto.SUSPENDED).length === 2 ? this.boxError() : null}
                                    {this.tilesList()}
                                </div>
                            )
                        ) : null}

                        {/* Staff */}
                        {this.state.userType === UserType.STAFF && !this.state.isLoading ? (
                            this.state.sameTerminalsType ? (
                                <div className={"user-details-container-content-table-second-column"}>
                                    <p className={"user-details-second-column-title"}>ID TERMINALE</p>
                                    <div className={"user-details-second-column-box"}>
                                        <div className={"user-details-terminal-info"}>
                                            <p className={"user-details-terminal-id"}>
                                                {this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined
                                                    ? "Nessuno"
                                                    : this.state.user?.terminalInfo![0].termId}
                                            </p>
                                            <StateBadge
                                                userState={
                                                    this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined
                                                        ? TidStatusDto.NOT_ASSIGNED
                                                        : this.state.user?.terminalInfo![0].terminalStatus
                                                }
                                            />
                                        </div>
                                        <Route
                                            render={({ history }) => {
                                                return (
                                                    <Button
                                                        id={"user-detail-button-change-tid"}
                                                        onClick={() =>
                                                            this.handleChangeTid(
                                                                history,
                                                                true,
                                                                this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined ? null : this.state.user?.terminalInfo![0].terminalStatus,
                                                                this.state.user?.terminalInfo?.length === 0 || this.state.user?.terminalInfo === undefined ? null : this.state.user?.terminalInfo![0].termId
                                                            )
                                                        }
                                                        disableRipple>
                                                        MODIFICA
                                                    </Button>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                // Multi POS Type
                                <div className={"user-details-container-content-table-second-column"}>
                                    <p className={"user-details-second-column-title"}>ID TERMINALE</p>
                                    {this.checkAndShowErrors()}
                                    {this.tilesList()}
                                </div>
                            )
                        ) : null}
                    </div>

                    {!this.state.isLoading ? (
                        <>
                            {/* Footer banner */}
                            {this.state.userType !== UserType.DEVELOPER ? (
                                this.state.sameTerminalsType ? (
                                    <>
                                        {this.state.terminalStatus === TidStatusDto.SUSPENDED && (
                                            <div className={"user-details-suspended-info"}>
                                                <p className={"user-details-info-title"}>Vuoi rendere l'utente nuovamente operativo?</p>
                                                <p className={"user-details-info-text"}>
                                                    Assegna un altro ID Terminale per accettare pagamenti oppure contatta il Servizio Clienti per approfondimenti.
                                                </p>
                                            </div>
                                        )}
                                        {this.state.terminalStatus === TidStatusDto.NOT_ASSIGNED && (
                                            <div className={"user-details-not-assigned-info"}>
                                                <p className={"user-details-info-title"}>Vuoi rendere l'utente nuovamente operativo?</p>
                                                <p className={"user-details-info-text"}>Assegnagli un ID terminale attivo per permettergli di accettare pagamenti.</p>
                                            </div>
                                        )}
                                    </>
                                ) : null
                            ) : null}
                            {this.state.userType === UserType.STAFF && (
                                <div className={"user-details-reset-password-container"}>
                                    <p className={"user-details-change-password-title"}>Invia una nuova password all'utente.</p>
                                    <Button
                                        id={"user-detail-button-reset-password"}
                                        onClick={() => {
                                            this.resetPassword();
                                        }}
                                        disableRipple>
                                        INVIA PASSWORD
                                    </Button>
                                </div>
                            )}
                        </>
                    ) : null}
                </div>

                <ConfirmDialog
                    id={this.state.userType === UserType.DEVELOPER ? "user-detail-developer-confirm-dialog" : undefined}
                    show={this.state.showConfirmForRevokeUser}
                    onClose={() => {
                        this.toggleRevokeUserModal();
                    }}
                    title="Sei davvero sicuro?"
                    content={this.state.userType === UserType.DEVELOPER ?
                        "Questo utente non potrà più accedere ai tuoi ID Terminali."
                        : "Questo utente non potrà più accedere all'App Nexi POS."
                    }
                    buttonNoText="ANNULLA"
                    buttonYesText="CONFERMO"
                    onConfirm={() => {
                        this.invokeRevokeUser();
                    }}
                />
                <ConfirmDialog
                    show={this.state.showConfirmForChangePwd}
                    onClose={() => {
                        this.toggleChangePwdModal();
                    }}
                    title={"Sei davvero sicuro?"}
                    content={
                        "Le attuali credenziali di questo utente non saranno più valide e il collaboratore non potrà incassare finchè non avrà inserito le nuove credenziali."
                    }
                    buttonNoText={"ANNULLA"}
                    buttonYesText={"CONFERMA"}
                    onConfirm={() => {
                        this.invokeResetPwd();
                    }}
                />
                {
                    // @ts-ignore
                    <MposLoader show={this.state.showLoader} />
                }
            </div>
        );
    }
    // Show result page functions
    private showRevokeUserResult() {
        let title = "Hai revocato con successo l'utenza di " + this.state.user?.email;
        this.props.history.push("/result", {
            isSuccess: this.state.revokeUserResult,
            title: title,
            message: "L'utente non potrà più accedere all'App Nexi POS per incassare in nome della tua attività.",
            button: "TORNA ALLE UTENZE",
            data: { from: "UserDetails", operation: "revokeUser" },
        });
    }

    private showRevokeDeveloperResult() {
        this.props.history.push("/activateDevResult", {
            isSuccess: this.state.revokeDeveloperResult,
            email: this.state.username,
            revokeDeveloperFlow: true
        });
    }

    private showChangePwdResult() {
        let title = "Email inviata con successo a " + this.state.user?.email;
        this.props.history.push("/result", {
            isSuccess: this.state.changePwdResult,
            title: title,
            message: "L'utente riceverà a breve le nuove credenziali con cui accedere all'App Nexi POS.",
            button: "VEDI ELENCO UTENZE",
            data: { from: "UserDetails", operation: "resetPwd" },
        });
    }

    /* Functions to manage user */
    // --- REVOKE USER
    private revokeUser() {
        this.setState({ showConfirmForRevokeUser: true });
        GoogleTagManagerService.getInstance().pushInteractionEvent("PopupImpression", "dettaglio utente secondario", "impression", "conferma revoca utenza");
    }

    private toggleRevokeUserModal = () => {
        this.setState({
            showConfirmForRevokeUser: !this.state.showConfirmForRevokeUser,
        });
    };

    private invokeRevokeUser() {
        this.setState({ showLoader: true });

        if (this.state.userType === UserType.DEVELOPER) {
            MposWebPortalApi.getInstance()
                .removeDeveloper(this.state.username)
                .subscribe((result) => {
                    switch (result) {
                        case HTTPResponses.OK:
                            this.setState(
                                {
                                    showLoader: false,
                                    showRevokeUserResultDialog: true,
                                    revokeDeveloperResult: true,
                                },
                            );
                            this.showRevokeDeveloperResult();
                            break;
                        case HTTPResponses.KO:
                        default:
                            this.setState(
                                {
                                    showLoader: false,
                                    showRevokeUserResultDialog: true,
                                    revokeDeveloperResult: false,
                                },
                            );
                            this.showRevokeDeveloperResult();
                            break;
                    }
                });
        } else {
            MposWebPortalApi.getInstance()
                .deleteUser(this.state.username)
                .subscribe(
                    () => {
                        this.setState({
                            showLoader: false,
                            showRevokeUserResultDialog: true,
                            revokeUserResult: true,
                        });
                        this.showRevokeUserResult();
                    },
                    () => {
                        this.setState({
                            showLoader: false,
                            showRevokeUserResultDialog: true,
                            revokeUserResult: false,
                        });
                        this.showRevokeUserResult();
                    }
                );
        }
    }

    // --- CHANGE TID
    private handleChangeTid(history: any, isEdit: boolean, terminalType?: string | null, terminalId?: string | null) {
        isEdit
            ? history.push("/chooseTidOperation", {
                user: this.state.user,
                terminalType: terminalType,
                selectedPos: terminalId,
                tidOperation:
                    this.state.userType === UserType.ADMIN
                        ? TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER
                        : TerminalOperationType.CHANGE_TERMINAL_ID_TO_STAFF_USER,
            })
            : history.push("/chooseTerminal", {
                user: this.state.user,
                headerTitle: "Modifica l'ID Terminale",
                terminalType: terminalType,
                tidOperation:
                    this.state.userType === UserType.ADMIN
                        ? TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER
                        : TerminalOperationType.CHANGE_TERMINAL_ID_TO_STAFF_USER,
                selectedPos: terminalId,
            });
    }

    // --- CHANGE INFO DESCRIPTION
    private handleChangeInfo() {
        this.setState({ updateUserModifyClicked: true });
    }

    private saveUserInfo(history: any) {
        this.setState({ updateUserModifyClicked: false });
        let user = this.state.user;
        if (user !== null) {
            user.description = this.state.descriptionValue;
            this.setState({ user: user }, () => {
                // Update on server
                let description = this.state.descriptionValue !== "" ? this.state.descriptionValue : null;
                let name = this.state.user?.name !== undefined ? this.state.user?.name : null;
                let surname = this.state.user?.surname !== undefined ? this.state.user?.surname : null;

                let request = new UpdateUserRequest(description, this.state.user?.email!, name, surname, this.state.user?.username!);
                MposWebPortalApi.getInstance()
                    .updateUserDetails(request)
                    .subscribe(
                        (result) => {
                            this.setState({ saveButtonDisabled: true });
                            if (result) {
                                // Send GTM event
                                GoogleTagManagerService.getInstance().pushInteractionEvent(
                                    "Success",
                                    "dettaglio utente secondario",
                                    "success",
                                    "conferma cambio ruolo o punto vendita"
                                );
                            }
                            // Update previous state with new infos
                            this.setState({ description: this.state.descriptionValue });
                            let queryParams = {
                                username: this.state.username,
                                userType: this.state.userType,
                                description: encodeURIComponent(this.state.descriptionValue),
                                terminalStatus: this.state.terminalStatus !== undefined ? this.state.terminalStatus : TidStatusDto.NOT_ASSIGNED,
                            };
                            let link = `/users/${this.state.username}?${querystring.stringify(queryParams)}`;
                            history.replace(link);
                        },
                        (error) => {
                            this.setState({ saveButtonDisabled: true });
                        }
                    );
            });
        }
    }

    // --- RESET PASSWORD
    private resetPassword() {
        this.setState({ showConfirmForChangePwd: true });
        GoogleTagManagerService.getInstance().pushInteractionEvent(
            "PopupImpression",
            "dettaglio utente secondario",
            "impression",
            "conferma invio nuove credenziali"
        );
    }

    private toggleChangePwdModal = () => {
        this.setState({
            showConfirmForChangePwd: !this.state.showConfirmForChangePwd,
        });
    };

    private invokeResetPwd() {
        this.setState({ showLoader: true });
        MposWebPortalApi.getInstance()
            .resetPassword(this.state.username, this.state.user?.email!)
            .subscribe(
                () => {
                    this.setState({ showLoader: false });
                    this.setState({ showChangePwdResultDialog: true });
                    this.setState({ changePwdResult: true });
                    this.showChangePwdResult();
                },
                () => {
                    this.setState({ showLoader: false });
                    this.setState({ showChangePwdResultDialog: true });
                    this.setState({ changePwdResult: false });
                    this.showChangePwdResult();
                }
            );
    }
}
